import { useEffect, useRef, useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";
import { api } from "../lib/api";

const sessionId = "rachel-" + Math.random().toString(36).slice(2);

export default function RachelWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    { role: "assistant", content: "Hello, I'm Rachel from Black Diamond Elite Cleaning. How can I help you today? I can explain our services, general pricing, or help you start a quote." },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || busy) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", content: text }]);
    setBusy(true);
    try {
      const { data } = await api.post("/public/rachel", { session_id: sessionId, message: text });
      setMsgs((m) => [...m, { role: "assistant", content: data.reply }]);
    } catch {
      setMsgs((m) => [...m, { role: "assistant", content: "I'm having trouble right now — please use our Contact form and we'll respond shortly." }]);
    } finally { setBusy(false); }
  };

  return (
    <>
      {!open && (
        <button data-testid="rachel-open-btn" onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-50 flex items-center gap-2 btn-gold px-5 py-3 rounded-full shadow-lg">
          <MessageCircle size={18} /> <span className="text-sm font-semibold">Ask Rachel</span>
        </button>
      )}
      {open && (
        <div data-testid="rachel-panel" className="fixed bottom-6 right-6 z-50 w-[92vw] max-w-sm h-[70vh] max-h-[560px] flex flex-col bg-[#0a0a0a] border border-[#333] rounded-lg overflow-hidden shadow-2xl">
          <div className="flex items-center justify-between px-4 py-3 border-b border-[#333] bg-[#111]">
            <div className="flex items-center gap-2">
              <span className="diamond" />
              <div>
                <p className="text-[#fdfbf7] text-sm font-semibold leading-none">Rachel</p>
                <p className="text-[#a3a3a3] text-[11px] mt-1">Black Diamond Reception · 09:00–17:00</p>
              </div>
            </div>
            <button data-testid="rachel-close-btn" onClick={() => setOpen(false)} className="text-[#a3a3a3] hover:text-[#d4af37]"><X size={18} /></button>
          </div>
          <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3 py-2 rounded-lg text-sm leading-relaxed ${m.role === "user" ? "bg-[#d4af37] text-[#0a0a0a]" : "bg-[#1c1c1c] text-[#e8e5de] border border-[#333]"}`}>
                  {m.content}
                </div>
              </div>
            ))}
            {busy && <div className="text-[#a3a3a3] text-xs px-1">Rachel is typing…</div>}
            <div ref={endRef} />
          </div>
          <div className="p-3 border-t border-[#333] flex gap-2">
            <input data-testid="rachel-input" value={input} onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Type your message…"
              className="flex-1 bg-[#1c1c1c] border border-[#333] text-[#fdfbf7] text-sm px-3 py-2 rounded-md placeholder:text-[#666]" />
            <button data-testid="rachel-send-btn" onClick={send} className="btn-gold px-3 rounded-md"><Send size={16} /></button>
          </div>
        </div>
      )}
    </>
  );
}
